import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from 'components/tooltip';

import './styles.scss';

export default function CrmTagsInputContactFormLabel() {
  return (
    <div className="d-flex align-items-center mb-2">
      <h6>Tags</h6>
      <Tooltip
        content={
          <div className="text-start pt-2">
            <p>
              Tags are a way to organize contacts for easy sorting,
              <br/>
              filtering, and list creation.
            </p>
            <p>They are public and visible to everyone on your team.</p>
          </div>
        }
        dark
        overlayClassName="crm-tags__input__tooltip"
        placement="right"
      >
        <FontAwesomeIcon className="ms-2" icon={faInfoCircle} />
      </Tooltip>
    </div>
  );
}
